import React from 'react';
import IconComponent from './iconComponent';

const ErrorDetails = ({error, errorDescription}) => (
    <div className='error-details-wrapper'>
        <div className='error-details'>
            <div className='alert-icon'>
                <IconComponent iconClassName="alert-circle-icon" />
            </div>
            <span className='error-detail'>
                {error}
            </span>
            <span className='error-detail'>
                {errorDescription}
            </span>
        </div>
    </div>
);

export default ErrorDetails;